/*
 * Copyright (c) 2026 Joseph Duggan. All rights reserved.
 */

import { useEffect, useState } from 'react';

/**
 * Track whether a CSS media query currently matches. SSR-safe: returns
 * false until mounted in a browser, then subscribes to changes.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange();
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}
